import { memo } from "react"

const IconPurchasePlans = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.9163 9.93996L7.98633 4.70996"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.916 9.93994V20.2899"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.4863 17.61L3.48633 12.5"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.4863 17.6099L21.4863 12.4199"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.98633 9.89996L16.9863 4.70996"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.98633 9.8999V20.2899"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.76367 7.46509L12.4857 12.5001L21.2067 7.46509"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M12.4863 12.5V22.57" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.4863 16.4959V8.50394C21.4863 7.76094 21.0903 7.07494 20.4473 6.70394L13.5253 2.70794C12.8823 2.33694 12.0903 2.33694 11.4473 2.70794L4.52533 6.70394C3.88233 7.07494 3.48633 7.76094 3.48633 8.50394V16.4959C3.48633 17.2389 3.88233 17.9249 4.52533 18.2959L11.4473 22.2919C12.0903 22.6629 12.8823 22.6629 13.5253 22.2919L20.4473 18.2959C21.0903 17.9249 21.4863 17.2389 21.4863 16.4959Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default memo(IconPurchasePlans)
